import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import * as serviceWorker from 'serviceWorker';

import { App } from 'App';
import { Buffer } from "buffer";
import process from "process";

import 'regenerator-runtime/runtime';
import 'custom-event-polyfill';
import 'isomorphic-fetch';
import 'core-js/stable';

//  Webpack 5 polyfills
if (!('process' in window)) window.process = process;
if (!('Buffer' in window)) window.Buffer = Buffer;

//// CONCURRENT MODE ////
const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
